import { FC } from 'react'
import Box from '@mui/material/Box'
import { DataLoad, DataLoggerList } from 'src/components'
import { useDataLoggerListRequest } from 'src/hooks/api'
import { useQueryParams } from 'src/hooks/ui'
import { defaultPage, defaultPerPage } from 'src/config'
import { DataLoggerGridColumns } from 'src/components/sections/dataLogger/dataLoggerColumns'

interface Props {
  contractorId: number;
}

const initialQueryParams = {
  page: `${defaultPage}`,
  rowsPerPage: `${defaultPerPage}`,
}
const columns = [
  DataLoggerGridColumns.DeviceId,
  DataLoggerGridColumns.Status,
  DataLoggerGridColumns.Label,
  DataLoggerGridColumns.Interval,
  DataLoggerGridColumns.FirstReadingDateTime,
  DataLoggerGridColumns.LastReadingDateTime,
  DataLoggerGridColumns.LastUploadDateTime,
  DataLoggerGridColumns.Project,
  DataLoggerGridColumns.Section,
  DataLoggerGridColumns.BatteryLevel,
  DataLoggerGridColumns.CreatedAt,
]

export const ContractorDataLoggerList: FC<Props> = ({
  contractorId,
}) => {
  const [queryParams, setQueryParams] = useQueryParams(initialQueryParams)
  const { isInitialLoading, isError, error, data } = useDataLoggerListRequest({
    params: {
      contractorId,
      ...queryParams,
    },
  })
  const exportedFileName = `${document.title}_data-pucks`

  return (
    <DataLoad isLoading={false} isError={isError} errorMessage={error?.message}>
      <Box height="500px">
        <DataLoggerList
          dataLoggerCount={data?.count || 0}
          dataLoggers={data?.rows || []}
          isLoading={isInitialLoading}
          setQueryParams={setQueryParams}
          queryParams={queryParams}
          autoHeight={false}
          exportedFileName={exportedFileName}
          tableColumns={columns}
        />
      </Box>
    </DataLoad>
  )
}
